import { SecondaryColors } from '@picsart/design-system/foundation/colors';

import { Spacings } from '@picsart/design-system/foundation/spacings';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles(
  {
    wrapper: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      gap: Spacings.s44,
    },
    title: {
      '& i': {
        color: ({ titleColor }: any) => titleColor || SecondaryColors.base.default,
        fontStyle: 'normal',
      },
    },
    // Skeleton
    titleSkeleton: {
      height: 60,
      width: '100%',
      maxWidth: 600,
    },
  },
  {
    name: 'pricing-card-section',
  },
);

export default useStyles;
